import { useCallback } from 'react';

import { createSearchParams, useNavigate } from 'react-router-dom';

import { RequestFragment } from '@/rtk-query.gql';

export function useSelect() {
  const navigate = useNavigate();
  return useCallback(
    (item: RequestFragment) => {
      navigate({
        pathname: '/issues/my-issues/detail',
        search: createSearchParams({
          requestId: item.id.toString(),
        }).toString(),
      });
    },
    [navigate],
  );
}
